import { render } from "./Home.vue?vue&type=template&id=21dd2b51&scoped=true&ts=true"
import script from "./Home.ts?vue&type=script&lang=ts"
export * from "./Home.ts?vue&type=script&lang=ts"

import "./Home.scss?vue&type=style&index=0&id=21dd2b51&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21dd2b51"]])

export default __exports__